module.exports = __webpack_public_path__ + "static/media/swords-emblem.add9b9bc.svg";